import type { Ctx } from "../../types";
import { Action, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";

export const delete_school: Action<Ctx> = async ({ sb }, _data, params) => {
  const school_id = params.get("id");
  if (!school_id) return { ok: false, error: "Missing id in URL" };

  const { error } = await sb.functions.invoke(`api/schools/${school_id}`, {
    method: "DELETE",
  });
  if (error) {
    toast({ variant: "error", text: "School delete failed. Try again" });
    return { ok: false, error: error.message };
  }
  invalidate("schools");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: "School deleted!" });
  return { ok: true };
};
